// Highlights the typed text in every open Autocomplete dropdown, app-wide.
const setupSearchHighlight = () => {
  const HighlightCtor = (window as any).Highlight;
  const registry = (window as any).CSS?.highlights;
  if (!HighlightCtor || !registry) return;

  const style = document.createElement('style');
  style.textContent = '::highlight(search-match) { background-color: #fff2a8; color: inherit; }';
  document.head.appendChild(style);

  const paint = () => {
    const input = document.activeElement as HTMLInputElement | null;
    const query = input?.classList?.contains('MuiAutocomplete-input') ? input.value.trim().toLowerCase() : '';
    const ranges: Range[] = [];
    if (query) {
      document.querySelectorAll('.MuiAutocomplete-listbox').forEach((list) => {
        const walker = document.createTreeWalker(list, NodeFilter.SHOW_TEXT);
        for (let node = walker.nextNode(); node; node = walker.nextNode()) {
          const text = (node.textContent || '').toLowerCase();
          for (let at = text.indexOf(query); at >= 0; at = text.indexOf(query, at + query.length)) {
            const range = new Range();
            range.setStart(node, at);
            range.setEnd(node, at + query.length);
            ranges.push(range);
          }
        }
      });
    }
    registry.set('search-match', new HighlightCtor(...ranges));
  };

  let frame = 0;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(paint);
  };

  // Watch the page only while a search box is focused.
  const observer = new MutationObserver(schedule);
  document.addEventListener('focusin', (e) => {
    if (!(e.target as HTMLElement)?.classList?.contains('MuiAutocomplete-input')) return;
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    schedule();
  });
  document.addEventListener('focusout', () => {
    observer.disconnect();
    schedule();
  });
  document.addEventListener('input', schedule, true);
};

export default setupSearchHighlight;
